<template>
  <div class="pa-6 overflow-hidden">
    <v-btn small @click="copyToClipboard">
      Copiar
    </v-btn>
    <pre class="scroll-y" v-if="rawdata != null">{{ rawdata | prettyHex }}</pre>
    <pre v-else-if="err != null">{{ err | prettyJson }}</pre>
  </div>
</template>

<script>
import { OrgApi } from '@/models'
import brush from 'brush'

export default {
  props: {
    value: {}
  },
  data() {
    return { rawdata: null, err: null }
  },
  watch: {
    value() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (this.value == null) return
      this.err = null
      this.rawdata == null

      let fetcher = new OrgApi(this.value.org.id),
        tid = this.value.mainTrip.id

      try {
        let str = await fetcher.get(`trips/${tid}/rawdata`)
        this.rawdata = brush.hexToBytes(str)
      } catch (err) {
        this.err = err
      }
    },

    copyToClipboard() {
      let str = brush.toHex(this.rawdata, {
        prettyPrint: true,
        bytesPerLine: 32,
        byteSep: '',
        groupSep: '  '
      })
      navigator.clipboard.writeText(str)
      this.$snack('Copied to clipboard')
    }
  },
  filters: {
    prettyHex(bytes) {
      if (bytes == null) return ''
      return brush.toHex(bytes, {
        prettyPrint: true,
        bytesPerLine: 32
      })
    }
  }
}
</script>

<style></style>
